import axios from 'axios';
import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import LoadHospital from './LoadData/LoadHospital';
import Loading from '../../Components/Loading/LoadingCenterPage';
import Autocomplete from '@mui/material/Autocomplete';
import { 
    GiftIcon, 
    CheckCircleIcon,
    BriefcaseIcon,
    MapPinIcon,
    PhoneIcon,
    CalendarDaysIcon,
    UserGroupIcon
} from '@heroicons/react/24/outline';
import { Chip, IconButton, Tooltip } from '@mui/material';

const ReportWelfareShirt = () => {

    const hosptal = LoadHospital()
    const [token] = React.useState(localStorage.getItem("token"));
    const [data, setData] = React.useState(null);
    const [dataGroup, setDataGroup] = React.useState(null);
    const [groupID, setGroupID] = React.useState(null);
    const [dataHosptal, setDataHospital] = React.useState(null);

    const handleChangeHospital = (event, newValue) => {
        const newHcode = newValue?.hcode;
        setData(null);
        getDataEmployeeHospital(newHcode);
    };

    const getDataEmployeeHospital = React.useCallback((targetHcode) => {
        axios({
            method: 'get',
            url: `https://www.phoenix-md.com/api/salary/config/hcode/read`,
            params: {
                hcode: targetHcode
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        }).then((res) => {
            if (!!res.data.results) {
                setGroupID(
                    Object.values(
                        res?.data?.results?.find(f =>
                            Array.isArray(f.agency) && f.agency.includes(targetHcode)
                        )?.employeeList || {}
                    )
                        .map(item => item?.employee_id)
                        .filter(Boolean)
                );
            }
        }).catch((error) => {
            console.log(error.message);
        });

    }, [token, setGroupID]);

    const getData = React.useCallback(() => {
        axios({
            method: 'post',
            url: `https://www.phoenix-md.com/api/personnel/employee/welfare/shirt/read`,
            data: groupID?.length > 0 ? { employeeID: groupID } : {},
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        }).then((res) => {
            if (!!res.data.results) {
                if (groupID?.length > 0) {
                    setDataGroup(res.data.results);
                } else {
                    setData(res.data.results);
                }
            }
        }).catch((error) => {
            console.log(error.message);
        });
    }, [token, setData, setDataGroup, groupID]);
    
    React.useEffect(() => {
        getData();
    }, [groupID, getData]);

    const date = (value) => {
        return new Date(value).toLocaleString('th-TH', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })
    }

    const handleCheck = (value) => {

        const form = document.getElementById('shirtRemark' + value.pid)
        const formData = new FormData(form);

        if (formData.get("shirtRemark") === "") {

            Swal.fire({
                title: "ไม่ได้ระบุหมายเหตุ",
                icon: 'error',
                confirmButtonText: "ตกลง",
                allowOutsideClick: () => {
                    const popup = Swal.getPopup()
                    popup.classList.remove('swal2-show')
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake')
                    })
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake')
                    }, 500)
                    return false
                },
            })

            return

        }

        Swal.fire({
            title: "ยืนยันบันทึก",
            icon: 'warning',
            showDenyButton: true,
            confirmButtonText: "ตกลง",
            denyButtonText: `ยกเลิก`,
            allowOutsideClick: () => {
                const popup = Swal.getPopup()
                popup.classList.remove('swal2-show')
                setTimeout(() => {
                    popup.classList.add('animate__animated', 'animate__headShake')
                })
                setTimeout(() => {
                    popup.classList.remove('animate__animated', 'animate__headShake')
                }, 500)
                return false
            },
        }).then((result) => {

            if (result.isConfirmed) {

                axios({
                    method: 'put',
                    url: `https://www.phoenix-md.com/api/personnel/employee/update`,
                    data: {
                        "welfare.shirt": "Yes",
                        "welfare.shirtRemark": formData.get("shirtRemark"),
                        _id: value._id,
                    },
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: token
                    }
                }).then((res) => {

                    if (res.data.status === "ok") {

                        Swal.fire({
                            title: "สำเร็จ",
                            icon: 'success',
                            confirmButtonText: "ตกลง",
                            allowOutsideClick: () => {
                                const popup = Swal.getPopup()
                                popup.classList.remove('swal2-show')
                                setTimeout(() => {
                                    popup.classList.add('animate__animated', 'animate__headShake')
                                })
                                setTimeout(() => {
                                    popup.classList.remove('animate__animated', 'animate__headShake')
                                }, 500)
                                return false
                            },
                        })

                        form.reset()

                    } else {

                        Swal.fire({
                            title: "ไม่สำเร็จ",
                            icon: 'error',
                            confirmButtonText: "ตกลง",
                            allowOutsideClick: () => {
                                const popup = Swal.getPopup()
                                popup.classList.remove('swal2-show')
                                setTimeout(() => {
                                    popup.classList.add('animate__animated', 'animate__headShake')
                                })
                                setTimeout(() => {
                                    popup.classList.remove('animate__animated', 'animate__headShake')
                                }, 500)
                                return false
                            },
                        })

                    }

                }).catch((error) => {

                    console.log(error.message)

                })

            }

        });

    }

    const checkHospital = (value) => {

        axios({
            method: 'get',
            url: `https://www.phoenix-md.com/api/salary/config/employee/id/read`,
            params: {
                _id: value._id,
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token
            }
        }).then((res) => {

            if (res.data.results.length === 0) {

                Swal.fire({
                    title: "ไม่พบสถานที่ทำงาน",
                    icon: 'error',
                    confirmButtonText: "ตกลง",
                    allowOutsideClick: () => {
                        const popup = Swal.getPopup()
                        popup.classList.remove('swal2-show')
                        setTimeout(() => {
                            popup.classList.add('animate__animated', 'animate__headShake')
                        })
                        setTimeout(() => {
                            popup.classList.remove('animate__animated', 'animate__headShake')
                        }, 500)
                        return false
                    },
                })

            }

            setDataHospital(res.data.results)

        })

    }

    return (
        <>
            {!!hosptal ? (
                <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-8">
                    <div className="max-w-[1800px] mx-auto">
                        
                        {/* Header Section */}
                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 md:p-8 mb-6">
                            <div className="flex items-center gap-4 mb-6">
                                <div className="p-3 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl shadow-lg">
                                    <GiftIcon className="h-8 w-8 text-white" />
                                </div>
                                <div>
                                    <h1 className="text-3xl font-black text-gray-900 tracking-tight">รายงานสวัสดิการเสื้อพนักงาน</h1>
                                    <p className="text-sm text-gray-500 mt-1">พนักงานที่มีอายุงานครบ 3 เดือน มีสิทธิ์รับเสื้อสวัสดิการ</p>
                                </div>
                            </div>

                            {/* Filter Section */}
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-4 border border-blue-200">
                                <div className="flex items-center gap-3 mb-3">
                                    <MapPinIcon className="h-5 w-5 text-blue-600" />
                                    <span className="text-sm font-bold text-blue-900">เลือกสถานพยาบาล</span>
                                </div>
                                <Autocomplete
                                    disablePortal
                                    options={hosptal}
                                    getOptionLabel={(option) => option.hname}
                                    sx={{ 
                                        bgcolor: 'white',
                                        borderRadius: 2,
                                        '& .MuiOutlinedInput-root': {
                                            '&:hover fieldset': { borderColor: '#4F46E5' },
                                        }
                                    }}
                                    required
                                    onChange={handleChangeHospital}
                                    renderInput={(params) => <TextField required {...params} label="สถานพยาบาล" />}
                                />
                            </div>

                            {/* Stats Cards */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                                <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-4 border border-green-200">
                                    <div className="flex items-center gap-3">
                                        <UserGroupIcon className="h-6 w-6 text-green-600" />
                                        <div>
                                            <p className="text-xs text-green-600 font-semibold uppercase">พนักงานที่มีสิทธิ์</p>
                                            <p className="text-2xl font-black text-green-900">
                                                {(groupID?.length > 0 ? dataGroup : data)?.length || 0}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-4 border border-amber-200">
                                    <div className="flex items-center gap-3">
                                        <GiftIcon className="h-6 w-6 text-amber-600" />
                                        <div>
                                            <p className="text-xs text-amber-600 font-semibold uppercase">สถานที่ที่เลือก</p>
                                            <p className="text-lg font-black text-amber-900">
                                                {groupID?.length > 0 ? 'กรองแล้ว' : 'ทั้งหมด'}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Table Section */}
                        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
                            <TableContainer sx={{ maxHeight: 650 }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {groupID?.length === 0 && (
                                                <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569' }}>
                                                    ที่ทำงาน
                                                </TableCell>
                                            )}
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 120 }}>
                                                วันที่เริ่มงาน
                                            </TableCell>
                                            <TableCell align="left" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 250 }}>
                                                ชื่อ - นามสกุล
                                            </TableCell>
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 200 }}>
                                                ตำแหน่ง
                                            </TableCell>
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 150 }}>
                                                เบอร์โทร
                                            </TableCell>
                                            <TableCell align="left" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 300 }}>
                                                ที่อยู่
                                            </TableCell>
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569', minWidth: 200 }}>
                                                หมายเหตุ
                                            </TableCell>
                                            <TableCell align="center" sx={{ bgcolor: '#F8FAFC', fontWeight: 800, fontSize: 13, py: 2.5, color: '#475569' }}>
                                                จัดการ
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {(groupID?.length > 0 ? dataGroup : data)?.map((v, i) => {
                                            return (
                                                <TableRow key={i} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    {groupID?.length === 0 && (
                                                        <TableCell align="center">
                                                            {dataHosptal?.[0]?.employeeList?.v?.employee_id !== v._id ? (
                                                                <Tooltip title="ตรวจสอบที่ทำงาน">
                                                                    <IconButton 
                                                                        onClick={() => checkHospital(v)}
                                                                        size="small"
                                                                        sx={{ bgcolor: '#EEF2FF', '&:hover': { bgcolor: '#E0E7FF' } }}
                                                                    >
                                                                        <BriefcaseIcon className="h-5 w-5 text-indigo-600" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ) : null}

                                                            {dataHosptal?.[0]?.employeeList?.v?.employee_id === v._id && (
                                                                <div className="space-y-1">
                                                                    {dataHosptal?.[0]?.agency.map((a, k) => (
                                                                        <Chip 
                                                                            key={k}
                                                                            label={hosptal?.find(f => f.hcode === a)?.hname || dataHosptal?.[0]?.nameConfig}
                                                                            size="small"
                                                                            sx={{ 
                                                                                bgcolor: '#DBEAFE', 
                                                                                color: '#1E40AF', 
                                                                                fontWeight: 700,
                                                                                fontSize: 11,
                                                                                mb: 0.5
                                                                            }}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </TableCell>
                                                    )}
                                                    <TableCell align="center">
                                                        <div className="flex items-center justify-center gap-2">
                                                            <CalendarDaysIcon className="h-4 w-4 text-gray-400" />
                                                            <span className="text-sm font-semibold text-gray-700">{date(v.firstDayOfWork)}</span>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <div className="py-2">
                                                            <p className="font-bold text-gray-900 text-sm">{v.label}</p>
                                                            <Chip 
                                                                label={`ชื่อเล่น: ${v.nickname}`}
                                                                size="small"
                                                                sx={{ 
                                                                    mt: 1,
                                                                    bgcolor: '#F3E8FF', 
                                                                    color: '#6B21A8', 
                                                                    fontWeight: 600,
                                                                    fontSize: 11
                                                                }}
                                                            />
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Chip 
                                                            label={v.positionJob}
                                                            sx={{ 
                                                                bgcolor: '#E0E7FF', 
                                                                color: '#4338CA', 
                                                                fontWeight: 700,
                                                                fontSize: 12
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <div className="flex items-center justify-center gap-2">
                                                            <PhoneIcon className="h-4 w-4 text-gray-400" />
                                                            <span className="font-mono text-sm font-semibold text-gray-700">{v.phone}</span>
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <div className="text-sm text-gray-600">
                                                            <p>{v.address}</p>
                                                            <Chip 
                                                                label={v.codeAddress}
                                                                size="small"
                                                                sx={{ 
                                                                    mt: 1,
                                                                    bgcolor: '#FEF3C7', 
                                                                    color: '#92400E', 
                                                                    fontWeight: 600,
                                                                    fontSize: 10
                                                                }}
                                                            />
                                                        </div>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Box
                                                            id={'shirtRemark' + v.pid}
                                                            component="form"
                                                            sx={{ display: 'flex', justifyContent: 'center' }}
                                                            noValidate
                                                            autoComplete="off"
                                                        >
                                                            <TextField 
                                                                required 
                                                                name='shirtRemark' 
                                                                type='text'
                                                                placeholder="เพิ่มหมายเหตุ..."
                                                                variant="outlined"
                                                                size="small"
                                                                sx={{ width: '200px' }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Tooltip title="ยืนยันการมอบเสื้อ">
                                                            <IconButton 
                                                                onClick={() => handleCheck(v)}
                                                                sx={{ bgcolor: '#ECFDF5', '&:hover': { bgcolor: '#D1FAE5' } }}
                                                            >
                                                                <CheckCircleIcon className="h-5 w-5 text-green-600" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            ) : (
                <Loading />
            )}
        </>
    )
}

export default ReportWelfareShirt
